var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"pt-10"},[_c('apexchart',{attrs:{"type":"donut","options":_vm.options,"series":_vm.data,"length":"350px","height":"350px"},on:{"dataPointSelection":_vm.handleClick}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }